import React from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { setLogin, setUserDetails } from "../Redux/userSlice/userSlice";

const useIsLoggedIn = () => {
  const userDetails = useSelector((state) => state.user?.userDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loginAgain = () => {    
      toast.error("Your session has expired. Please login again.");
      dispatch(setUserDetails(undefined));
      dispatch(setLogin(false));
      navigate('/', {replace: true})
      navigate('/booking')
  }

  const isLoginExpired = () => {
    if (!userDetails?.access) {
      return true;
    }
    const decodedToken = jwtDecode(userDetails?.access);
    const currentTime = Math.floor(Date.now() / 1000);
    // Check if token is expired
    return decodedToken.exp < currentTime;
  };
  return { isLoginExpired, loginAgain };
};

export default useIsLoggedIn;
